import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid,
  Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  DELETE_GROUPS_ERROR,
  DELETE_GROUPS_SUCCESS,
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
  HOF_DASHBOARD_ERROR,
  HOF_DASHBOARD_SUCCESS,
} from "../../store/types/billTypes";
import { useLocation, useNavigate } from "react-router";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import {
  downloadHofPdf,
  setBillReducer,
} from "../../store/actions/billActions";
import CoreDataTableDashboard from "../../core/dataDisplay/datatable/CoreDataTableDashboard";

import CoreSelect from "../../core/inputs/CoreSelect";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { theme } from "../../config/theme";

export default function HofDashboard() {
  const users = useSelector((state) => state.bill.userDocs);
  const user = useSelector((state) => state.auth.user);
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);
  const deleteGroupSuccess = useSelector(
    (state) => state.bill.deleteGroupSuccess,
  );
  const deleteGroupError = useSelector((state) => state.bill.deleteGroupError);
  const tools = useSelector((state) => state.common.tools);
  const hofDashboardData = useSelector((state) => state.bill.hofDashboardData);
  const location = useLocation();

  const tool = location.pathname.split("/")[1];
  const toolMeta = tools?.find((t) => t.name === tool)?.extraInfo?.dashboard;

  const [open, setModal] = useState(false);
  const [columns, setColumns] = useState([]);
  const [selDocGroup, setSelDocGroup] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setModal(false);
    getData();
    dispatch(
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
    );

    return () => {
      dispatch(
        setBillReducer({
          groupDocsSuccess: false,
          groupDocsError: false,
          deleteGroupSuccess: false,
          deleteGroupError: false,
          hofDashboardSuccess: false,
          hofDashboardError: null,
          hofDashboardData: null,
        }),
      );
      setSelDocGroup(null);
    };
  }, []);

  useEffect(() => {
    if (users && users.length) {
      let cols = users[0] ? Object.keys(users[0]?.info?.criteria) : [];
      cols = cols?.map((col) => {
        console.log("COL ", typeof users[0]?.info?.criteria[col]);
        return {
          name: col,
          isBoolean: typeof users[0]?.info?.criteria[col] === "boolean",
        };
      });

      setColumns(cols);
    }
  }, [users]);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      dispatch(
        setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
      );
    }
    if (groupDocsError) {
      alert("Internal error");
      dispatch(
        setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
      );
    }
  }, [groupDocsSuccess, groupDocsError]);

  useEffect(() => {
    if (deleteGroupSuccess) {
      getData();
      dispatch(
        setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false }),
      );
    }
    if (deleteGroupError) {
      alert("Internal error");
      dispatch(
        setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false }),
      );
    }
  }, [deleteGroupSuccess, deleteGroupError]);
  useEffect(() => {
    if (selDocGroup) {
      getHofData();
    }
  }, [selDocGroup]);

  const getData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/DocGroups",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ userId: user.id, tool, type: "basic" }),
          ),
        },
        null,
        FETCH_DOC_USERS_SUCCESS,
        FETCH_DOC_USERS_ERROR,
        true,
        false,
      ),
    );
  };

  const viewDocs = (row) => {
    navigate("/" + tool + "/docs/view", {
      state: { docGroupId: row.id, label: row.fieldValue },
    });
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  const downloadPdf = (row) => {
    console.log("Downloading pdf for ", row);
    dispatch(downloadHofPdf(row.id));
  };

  const getHofData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/api/hof/dashboard",
        { docGroupId: selDocGroup },
        {},
        null,
        HOF_DASHBOARD_SUCCESS,
        HOF_DASHBOARD_ERROR,
        true,
        false,
      ),
    );
  };

  const deleteGroups = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/groups/delete/all",
        {},
        {},
        null,
        DELETE_GROUPS_SUCCESS,
        DELETE_GROUPS_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  console.log("cols ", tools, toolMeta, users, hofDashboardData);

  const getRoleColor = (role) => {
    const r = (role || "").toUpperCase();
    if (r.includes("HOF") || r.includes("FATHER"))
      return { main: "#1976d2", light: "#e3f2fd" };
    if (r.includes("SON") || r.includes("BROTHER") || r.includes("HUSBAND"))
      return { main: "#00897b", light: "#e0f2f1" };
    if (r.includes("DAUGHTER") || r.includes("SISTER") || r.includes("WIFE"))
      return { main: "#7b1fa2", light: "#f3e5f5" };
    return { main: "#607d8b", light: "#eceff1" };
  };

  const renderMemberCard = (data, role) => {
    const color = getRoleColor(role);
    return (
      <Paper
        elevation={1}
        style={{
          borderRadius: 12,
          border: `1.5px solid ${color.main}`,
          overflow: "hidden",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box style={{ padding: 16, flex: 1 }}>
          <Box
            style={{ display: "flex", alignItems: "center", marginBottom: 12 }}
          >
            <Avatar
              style={{
                width: 64,
                height: 64,
                backgroundColor: color.light,
                border: `2px solid ${color.main}`,
                marginRight: 12,
              }}
            >
              <Icon style={{ color: color.main, fontSize: 36 }}>person</Icon>
            </Avatar>
            <Box>
              <Typography variant="h6" style={{ fontWeight: 700 }}>
                {data?.Name || data?.name || ""}
              </Typography>
              <Chip
                icon={<Icon style={{ fontSize: 16 }}>person</Icon>}
                label={role.toUpperCase()}
                size="small"
                style={{
                  backgroundColor: color.light,
                  color: color.main,
                  fontWeight: 700,
                  fontSize: 11,
                  letterSpacing: 0.5,
                  marginBottom: 12,
                }}
              />
            </Box>
          </Box>
          {Object.entries(data || {})
            .filter(([k]) => !["Name", "name", "Role", "role"].includes(k))
            .map(([key, value]) => (
              <Box key={key} style={{ marginBottom: 8 }}>
                <Typography
                  variant="caption"
                  style={{ color: "#888", display: "block" }}
                >
                  {key}
                </Typography>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                  {value}
                </Typography>
              </Box>
            ))}
        </Box>
        <Box
          style={{
            backgroundColor: "#f1f8f4",
            borderTop: "1px solid #c8e6c9",
            padding: "8px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon style={{ color: "#2e7d32", fontSize: 18, marginRight: 4 }}>
            check_circle
          </Icon>
          <Typography
            variant="body2"
            style={{ color: "#2e7d32", fontWeight: 600 }}
          >
            Source: Aadhar card
          </Typography>
        </Box>
      </Paper>
    );
  };

  const renderSummaryTable = () => {
    const hof = hofDashboardData?.hofData || {};
    const members = hofDashboardData?.memberData || [];
    const allMembers = [
      { ...hof, _role: "HOF" },
      ...members.map((m, i) => ({
        ...m,
        _role: m.Role || m.Relation || `MEMBER ${i + 1}`,
      })),
    ];
    const skip = new Set(["Role", "role", "_role"]);
    const fieldSet = new Set();
    allMembers.forEach((m) =>
      Object.keys(m).forEach((k) => !skip.has(k) && fieldSet.add(k)),
    );
    const fields = Array.from(fieldSet).filter(
      (f) => f !== "Name" && f !== "name",
    );
    return (
      <TableContainer
        component={Paper}
        elevation={1}
        style={{ borderRadius: 12 }}
      >
        <Table size="small">
          <TableHead>
            <TableRow style={{ backgroundColor: "#fafafa" }}>
              <TableCell style={{ fontWeight: 700, width: 160 }}>
                Field
              </TableCell>
              {allMembers.map((m, i) => (
                <TableCell key={i} align="center">
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <Chip
                      icon={<Icon style={{ fontSize: 14 }}>person</Icon>}
                      label={m._role}
                      size="small"
                      style={{ fontSize: 10 }}
                    />
                    <Typography variant="body2" style={{ fontWeight: 700 }}>
                      {m.Name || m.name || ""}
                    </Typography>
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((field) => (
              <TableRow key={field} hover>
                <TableCell style={{ color: "#555", fontWeight: 500 }}>
                  {field}
                </TableCell>
                {allMembers.map((m, i) => (
                  <TableCell key={i} align="center">
                    {m[field] || <span style={{ color: "#bbb" }}>—</span>}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box style={{ padding: "8px 16px", borderTop: "1px solid #eee" }}>
          <Typography variant="caption" style={{ color: "#888" }}>
            <Icon
              style={{ fontSize: 14, verticalAlign: "middle", marginRight: 4 }}
            >
              info
            </Icon>
            All dates are in DD/MM/YYYY format
          </Typography>
        </Box>
      </TableContainer>
    );
  };

  const renderMismatches = () => {
    const mismatches = hofDashboardData?.mismatches || [];
    const getSeverityColor = (severity) => {
      if ((severity || "").toUpperCase() === "HIGH")
        return { bg: "#fdecea", text: "#c62828", border: "#ef9a9a" };
      if ((severity || "").toUpperCase() === "MEDIUM")
        return { bg: "#fff3e0", text: "#e65100", border: "#ffcc80" };
      return { bg: "#e8f5e9", text: "#2e7d32", border: "#a5d6a7" };
    };
    return (
      <Paper
        elevation={1}
        style={{
          borderRadius: 12,
          overflow: "hidden",
          backgroundColor: theme.palette.error.light,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            padding: "12px 16px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 700,
              color: theme.palette.error.main,
              flex: 1,
            }}
          >
            Data Mismatches
          </Typography>
          {mismatches.length > 0 && (
            <Box
              style={{
                backgroundColor: "#e65100",
                color: "#fff",
                borderRadius: "50%",
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              {mismatches.length}
            </Box>
          )}
        </Box>
        <Box
          style={{
            padding: 12,
            overflowY: "auto",
            flex: 1,
          }}
        >
          {mismatches.length === 0 ? (
            <Box style={{ textAlign: "center", padding: 24 }}>
              <Icon style={{ color: "#81c784", fontSize: 40 }}>
                check_circle
              </Icon>
              <Typography
                variant="body2"
                style={{ color: "#555", marginTop: 8 }}
              >
                No mismatches found
              </Typography>
            </Box>
          ) : (
            Array.isArray(mismatches) &&
            mismatches?.slice(0, 3).map((m, i) => {
              const sevColor = getSeverityColor(m.severity);
              return (
                <Paper
                  key={i}
                  elevation={0}
                  style={{
                    border: `1px solid ${sevColor.border}`,
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 10,
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 6,
                    }}
                  >
                    <Icon
                      style={{
                        color: sevColor.text,
                        fontSize: 18,
                        marginRight: 6,
                      }}
                    >
                      warning
                    </Icon>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 700, flex: 1 }}
                    >
                      {m.title}
                    </Typography>
                    <Box
                      style={{
                        backgroundColor: sevColor.bg,
                        color: sevColor.text,
                        padding: "2px 8px",
                        borderRadius: 4,
                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {m.severity}
                    </Box>
                  </Box>
                  <Typography
                    variant="caption"
                    style={{ color: "#666", display: "block", marginBottom: 8 }}
                  >
                    {m.details}
                  </Typography>
                  {m.comparisons?.map((c, j) => (
                    <Box
                      key={j}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 4,
                      }}
                    >
                      <Typography variant="caption" style={{ color: "#888" }}>
                        {c.label}
                      </Typography>
                      <Typography
                        variant="caption"
                        style={{
                          fontWeight: 600,
                          color: c.highlight ? sevColor.text : "#333",
                        }}
                      >
                        {c.value}
                      </Typography>
                    </Box>
                  ))}
                </Paper>
              );
            })
          )}
          {mismatches.length > 3 && (
            <Box style={{ textAlign: "center", marginTop: 8 }}>
              <Button size="small" endIcon={<Icon>arrow_forward</Icon>}>
                View All Mismatches
              </Button>
            </Box>
          )}
          {mismatches.length > 0 && mismatches.length <= 3 && (
            <Box style={{ textAlign: "center", marginTop: 8 }}>
              <Button size="small" endIcon={<Icon>arrow_forward</Icon>}>
                View All Mismatches
              </Button>
            </Box>
          )}
        </Box>
      </Paper>
    );
  };

  return (
    <Box style={{ width: "100%", height: "calc(100vh - 96px)" }}>
      <Box
        style={{
          padding: 16,
          paddingTop: 8,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={2} alignItems="center" style={{ padding: 8 }}>
          <Grid xs={6}>
            <Typography
              variant="h6"
              style={{ fontWeight: 700, marginBottom: 0 }}
            >
              Extracted Family Members
            </Typography>
          </Grid>
          <Grid
            xs={6}
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <Box style={{ width: 240, marginTop: -8 }}>
              <CoreSelect
                handleChange={(e) => {
                  console.log("Selected ", e.target.value);
                  setSelDocGroup(e.target.value);
                }}
                value={selDocGroup || ""}
                options={users?.map((row) => ({
                  id: row.id,
                  label: row.fieldName + " : " + row.fieldValue,
                }))}
                label="Select Application"
              />
            </Box>
            <CoreIconButton onClick={groupData}>
              <Icon>sync</Icon>
            </CoreIconButton>
            {hofDashboardData && (
              <>
                <CoreIconButton onClick={deleteGroups}>
                  <Icon>delete_all</Icon>
                </CoreIconButton>
                <Box>
                  <CoreContainedButton
                    size="small"
                    startIcon={<Icon>picture_as_pdf</Icon>}
                    onClick={() => dispatch(downloadHofPdf(selDocGroup))}
                    disabled={!selDocGroup}
                  >
                    Download PDF
                  </CoreContainedButton>
                </Box>
              </>
            )}
          </Grid>
        </Grid>

        <Box
          style={{
            flex: 1,
            overflow: "hidden",
            marginTop: 16,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {hofDashboardData && (
            <Box
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid
                container
                spacing={2}
                style={{
                  flex: 1,
                  overflow: "hidden",
                  flexWrap: "nowrap",
                  height: "100%",
                }}
              >
                {/* Member cards + summary table */}
                <Grid
                  item
                  xs={12}
                  md={9}
                  style={{
                    height: "100%",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      overflowX: "auto",
                      overflowY: "hidden",
                      gap: 16,
                      paddingBottom: 8,
                      flex: 1,
                      alignItems: "stretch",
                    }}
                  >
                    <Box
                      style={{
                        minWidth: 260,
                        flexShrink: 0,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {renderMemberCard(hofDashboardData.hofData, "HOF")}
                    </Box>
                    {hofDashboardData.memberData?.map((member, idx) => (
                      <Box
                        key={idx}
                        style={{
                          minWidth: 260,
                          flexShrink: 0,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {renderMemberCard(
                          member,
                          member.Role || member.Relation || "MEMBER",
                        )}
                      </Box>
                    ))}
                  </Box>

                  {/* <Box style={{ marginTop: 24 }}>
                    <Typography
                      variant="h6"
                      style={{ fontWeight: 700, marginBottom: 12 }}
                    >
                      Family Details Summary
                    </Typography>
                    {renderSummaryTable()}
                  </Box> */}
                </Grid>

                {/* Mismatches sidebar */}
                <Grid
                  item
                  xs={12}
                  md={3}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {renderMismatches()}
                </Grid>
              </Grid>
            </Box>
          )}

          {!hofDashboardData && selDocGroup && (
            <Typography
              variant="body2"
              style={{ color: "#aaa", marginTop: 24, textAlign: "center" }}
            >
              Loading dashboard data...
            </Typography>
          )}

          {!selDocGroup && (
            <Typography
              variant="body2"
              style={{ color: "#aaa", marginTop: 24, textAlign: "center" }}
            >
              Select a HOF to view family details.
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
